<template>
  <div>
    <div id="topup" class="mt-5 mb-2 py-3">
      <h1>Top Up</h1>
      <TopUpModal
        :isOpen="topUpModal.isOpen"
        :title="topUpModal.title"
        :onClose="onCloseTopUpModal"
        :onSubmit="topUp"
        :listPaymentMethod="paymentMethod"
        :key="topUpModalComponentKey"
      />
      <DetailsTopUpModal
        :isOpen="detailsTopUpModal.isOpen"
        :title="detailsTopUpModal.title"
        :onClose="onCloseDetailsTopUpModal"
        :summary="modalData"
        :onNext="onCheckTransactionStatus"
        :key="detailsTopUpModalComponentKey"
      />
      <SuccessTopUpModal
        :isOpen="successTopUpModal.isOpen"
        :title="successTopUpModal.title"
        :onClose="onCloseSuccessTopUpModal"
        :summary="modalData"
      />
      <ExpiredTopUpModal
        :isOpen="expiredTopUpModal.isOpen"
        :title="expiredTopUpModal.title"
        :onClose="onCloseExpiredTopUpModal"
        :summary="modalData"
      />
      <WaitingPaymentTopUpModal
        :isOpen="waitingPaymentTopUpModal.isOpen"
        :title="waitingPaymentTopUpModal.title"
        :onClose="onCloseWaitingPaymentTopUpModal"
        :summary="modalData"
      />
    </div>
    <div>
      <Waiting v-if="loading" />
      <v-layout row wrap>
        <v-flex xs12>
          <div id="topup-content-wrapper" class="content-wrapper">
            <v-layout row wrap>
              <v-flex lg4 md12 sm12>
                <div class="balance-info" data-v-step="1">
                  <v-container grid-list-md text-xs-center>
                    <v-layout
                      wrap
                      align-center
                      fill-height
                      :row="mobileScreen"
                      :column="mobileScreen"
                      :reverse="mobileScreen"
                    >
                      <v-flex lg6 sm12>
                        <label
                          class="title font-weight-bold blue-grey--text mb-0"
                        >
                          Balance
                          <v-icon
                            class="ref-btn"
                            color="primary"
                            @click="onRefresh"
                          >
                            mdi-update
                          </v-icon>
                        </label>
                      </v-flex>
                      <v-flex lg6 sm12>
                        <v-btn
                          round
                          color="success"
                          dark
                          class="text-capitalize"
                          @click="openTopUpModal"
                        >
                          <v-icon class="pr-2" dark> mdi-plus-circle </v-icon>
                          Top Up
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-container>
                  <v-container grid-list-md text-xs-center>
                    <v-layout
                      row
                      wrap
                      align-center
                      justify-center
                      column
                      fill-height
                      lg-mt-5
                      lg-py-1
                      lg-mb-1
                    >
                      <v-flex xs12>
                        <label
                          class="font-weight-bold blue-grey--text"
                          v-bind:class="{
                            'body-2': mobileScreen === true,
                            'display-1': mobileScreen === false
                          }"
                        >
                          <p v-if="balance" class="mb-0">
                            {{ balance }}
                          </p>
                          <p v-else class="mb-0">Loading...</p>
                        </label>
                      </v-flex>
                      <v-flex xs12>
                        <label
                          class="subtitle font-weight-bold grey--text"
                          v-bind:class="{
                            caption: mobileScreen === true,
                            'body-2': mobileScreen === false
                          }"
                        >
                          <p v-if="balance" class="mb-0">
                            Last Check:
                            <br v-if="mobileScreen" />
                            {{ date }},
                            <br v-if="mobileScreen" />
                            {{ hour }} : {{ min }} :
                            {{ sec }}
                          </p>
                          <p v-else class="mb-0">Loading...</p>
                        </label>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </div>
              </v-flex>

              <v-flex lg8 md12 sm12>
                <div class="balance-filter" data-v-step="2">
                  <v-layout align-center justify-space-between row fill-height>
                    <label class="title font-weight-bold blue-grey--text">
                      Filter
                    </label>
                  </v-layout>
                  <v-layout align-start justify-start row fill-height>
                    <v-container
                      grid-list-md
                      text-xs-center
                      class="px-0 pb-0 pt-2"
                    >
                      <v-layout row wrap>
                        <v-flex xs6>
                          <v-select
                            :items="status"
                            label="Status"
                            v-model="temporaryFilter.status"
                            solo
                          ></v-select>
                        </v-flex>
                        <v-flex xs6>
                          <v-menu
                            ref="menu1"
                            :close-on-content-click="false"
                            v-model="menu1"
                            :nudge-right="40"
                            :return-value.sync="filters.start"
                            lazy
                            transition="scale-transition"
                            offset-y
                            full-width
                            min-width="290px"
                          >
                            <v-text-field
                              class="m-10"
                              solo
                              slot="activator"
                              v-model="filters.start"
                              append-icon="mdi-calendar"
                              label="Start Date"
                              @input="menu1 = false"
                            ></v-text-field>
                            <v-date-picker
                              v-model="filters.start"
                              @input="$refs.menu1.save(filters.start)"
                              no-title
                              scrollable
                              :allowed-dates="allowedDates"
                              next-icon="mdi-chevron-right"
                              prev-icon="mdi-chevron-left"
                            >
                            </v-date-picker>
                          </v-menu>
                        </v-flex>
                        <v-flex xs6>
                          <v-select
                            :items="paymentMethod"
                            label="Payment Method"
                            v-model="temporaryFilter.paymentMethod"
                            solo
                          >
                          </v-select>
                        </v-flex>
                        <v-flex xs6>
                          <v-menu
                            ref="menu2"
                            :close-on-content-click="false"
                            v-model="menu2"
                            :nudge-right="40"
                            :return-value.sync="filters.end"
                            lazy
                            transition="scale-transition"
                            offset-y
                            full-width
                            min-width="290px"
                          >
                            <v-text-field
                              class="m-10"
                              solo
                              slot="activator"
                              v-model="filters.end"
                              append-icon="mdi-calendar"
                              label="End Date"
                              @input="menu2 = false"
                            ></v-text-field>
                            <v-date-picker
                              v-model="filters.end"
                              @input="$refs.menu2.save(filters.end)"
                              no-title
                              scrollable
                              :allowed-dates="allowedDates"
                              next-icon="mdi-chevron-right"
                              prev-icon="mdi-chevron-left"
                            >
                            </v-date-picker>
                          </v-menu>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-layout>
                  <v-layout align-center justify-end row fill-height>
                    <v-btn
                      class="green white--text text-none"
                      @click="onApplyFilter()"
                    >
                      Apply
                    </v-btn>
                    <v-btn
                      class="red darken-3 white--text text-none"
                      @click="resetFilter()"
                    >
                      Reset
                    </v-btn>
                  </v-layout>
                </div>
              </v-flex>
            </v-layout>

            <v-layout align-center justify-end row fill-height>
              <v-flex lg4 mx-1>
                <v-text-field
                  class="m-10"
                  solo
                  v-model="search"
                  placeholder="Search"
                  append-icon="mdi-magnify"
                  data-v-step="3"
                >
                </v-text-field>
              </v-flex>
            </v-layout>

            <v-data-table
              :headers="headers"
              :items="lists"
              :search="search"
              :rows-per-page-items="rowsPerPageItems"
              :pagination.sync="pagination"
              class="elevation-1 ma-1 row-cursor-pointer"
              data-v-step="4"
            >
              <template slot="items" slot-scope="props">
                <tr @click="onRowClicked(props.item)">
                  <td>
                    {{
                      props.index +
                        1 +
                        (pagination.page - 1) * pagination.rowsPerPage
                    }}
                  </td>
                  <td class="text-xs-left">
                    {{ props.item.created_date }}
                  </td>
                  <td class="text-xs-left">
                    {{ props.item.distributor_balance_order_number }}
                  </td>
                  <td class="text-xs-left">
                    {{ props.item.amount }}
                  </td>
                  <td class="text-xs-left">
                    {{ props.item.va_payment_fee }}
                  </td>
                  <td class="text-xs-left">
                    {{ props.item.va_gross_amount }}
                  </td>
                  <td class="text-xs-center">
                    <p
                      class="font-weight-bold mb-0"
                      v-bind:class="{
                        'red--text':
                          props.item.status_bo.toLowerCase() === 'cancel',
                        'orange--text':
                          props.item.status_bo.toLowerCase() === 'open',
                        'green--text':
                          props.item.status_bo.toLowerCase() === 'closed'
                      }"
                    >
                      {{ props.item.status_bo.toUpperCase() }}
                    </p>
                  </td>
                  <td class="text-xs-left">
                    {{ props.item.va_expired_at }}
                  </td>
                </tr>
              </template>
              <v-alert
                slot="no-results"
                :value="true"
                color="error"
                icon="mdi-alert"
              >
                Your search for "{{ search }}" found no results.
              </v-alert>
              <template slot="no-data" v-if="!loading">
                <v-alert :value="true" color="error" icon="mdi-alert">
                  No result for top up activity.
                </v-alert>
              </template>
            </v-data-table>
          </div>
        </v-flex>
      </v-layout>
    </div>
    <v-tour name="topupTour" :steps="steps" :callbacks="myCallbacks"></v-tour>
  </div>
</template>
<script>
import axios from '@/helpers/axios'
import moment from 'moment'
import { mapState } from 'vuex'
import { currencyRupiah } from '@/helpers/currency'
import TopUpModal from '@/components/TopUpModal.vue'
import DetailsTopUpModal from '@/components/DetailsTopUpModal.vue'
import SuccessTopUpModal from '@/components/SuccessTopUpModal.vue'
import WaitingPaymentTopUpModal from '@/components/WaitingPaymentTopUpModal.vue'
import ExpiredTopUpModal from '@/components/ExpiredTopUpModal.vue'
import Waiting from '@/components/Waiting.vue'

export default {
  name: 'TopUp',
  components: {
    TopUpModal,
    DetailsTopUpModal,
    SuccessTopUpModal,
    WaitingPaymentTopUpModal,
    ExpiredTopUpModal,
    Waiting
  },
  data () {
    return {
      steps: [
        {
          target: '[data-v-step="1"]',
          header: {
            title: 'Selamat datang di Panduan Top Up'
          },
          content:
            'Ini merupakan panel informasi saldo pengguna. Lakukan refresh secara berkala dengan cara klik ikon <i class="v-icon ref-btn v-icon--link mdi mdi-update theme--light primary--text"></i> Apabila Anda ingin melakukan Top Up, klik tombol dengan ikon  <i class="v-icon ref-btn v-icon--link mdi mdi-plus-circle theme--light white--text"></i> Top Up',
          params: {
            placement: 'top' // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
          }
        },
        {
          target: '[data-v-step="2"]',
          content:
            'Ini merupakan panel filter, digunakan untuk menyaring informasi sesuai dengan kebutuhan penyaringan data pengguna.',
          params: {
            placement: 'top' // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
          }
        },
        {
          target: '[data-v-step="3"]',
          content:
            'Ini merupakan kotak pencarian, pada kotak ini, pengguna dapat melakukan pencarian terhadap Order Number dengan mudah.',
          params: {
            placement: 'top' // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
          }
        },
        {
          target: '[data-v-step="4"]',
          content:
            'Ini merupakan tabel data, berisi data aktivitas Top Up yang telah user lakukan, diramdengan tampilan awal yaitu transaksi pada bulan ini.',
          params: {
            placement: 'top' // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
          }
        }
      ],
      myCallbacks: {
        onFinish: this.myCustomFinishStepCallback,
        onSkip: this.myCustomFinishStepCallback
      },
      detailsTopUpModalComponentKey: +new Date() + 1,
      topUpModalComponentKey: +new Date(),
      balance: 0,
      date: '-',
      hour: '00',
      min: '00',
      sec: '00',
      status: ['Closed', 'Open', 'Cancel'],
      paymentMethod: [],
      menu1: false,
      menu2: false,
      search: '',
      temporaryFilter: {
        status: '',
        paymentMethod: '',
        topUpDate: ''
      },
      appliedFilter: {
        status: '',
        paymentMethod: '',
        topUpDate: ''
      },
      headers: [
        {
          text: 'No.',
          align: 'center',
          sortable: false,
          value: 'name'
        },
        { text: 'Date/Time', value: 'created_date' },
        { text: 'Order Number', value: 'distributor_balance_order_number' },
        { text: 'Nominal', value: 'amount' },
        { text: 'Payment Fee', value: 'va_payment_fee' },
        { text: 'Total Transfer', value: 'va_gross_amount' },
        {
          text: 'Status',
          value: 'status_bo',
          align: 'center',
          sortable: false
        },
        { text: 'Expired At', value: 'va_expired_at' }
      ],
      topUpModal: {
        isOpen: false,
        title: 'Top Up Balance'
      },
      detailsTopUpModal: {
        isOpen: false,
        title: 'Payment Details'
      },
      successTopUpModal: {
        isOpen: false,
        title: 'Top Up Successful!'
      },
      expiredTopUpModal: {
        isOpen: false,
        title: 'Oops! Your payment has been expired'
      },
      waitingPaymentTopUpModal: {
        isOpen: false,
        title: 'Waiting Payment Status'
      },
      modalData: {},
      pagination: {
        page: 1,
        rowsPerPage: 10,
        totalItems: 100000,
        sortBy: 'created_date', // The field that you're sorting by
        descending: true
      },
      lists: [],
      details: [],
      loading: true,
      rowsPerPageItems: [10, 25, 50, 100],
      filters: {
        start: new Date(Date.now() - 259200000).toISOString().substr(0, 10),
        end: new Date().toISOString().substr(0, 10)
      },
      defaultFilters: {
        start: new Date(Date.now() - 259200000).toISOString().substr(0, 10),
        end: new Date().toISOString().substr(0, 10)
      }
    }
  },
  computed: {
    mobileScreen: function () {
      return window.screen.availWidth <= 540
    },
    ...mapState(['appid', 'appkey', 'token'])
  },
  methods: {
    myCustomFinishStepCallback () {
      localStorage.setItem('guideTopUp', 'read')
    },
    allowedDates: function (val) {
      return val <= new Date().toISOString().substr(0, 10)
    },
    openTopUpModal () {
      this.topUpModal.isOpen = true
    },
    onCloseTopUpModal () {
      this.topUpModal.isOpen = false
      this.forceRerender()
    },
    openDetailsTopUpModal () {
      this.detailsTopUpModal.isOpen = true
      this.forceRerender()
    },
    onCloseDetailsTopUpModal () {
      this.detailsTopUpModal.isOpen = false
    },
    openSuccessTopUpModal () {
      this.successTopUpModal.isOpen = true
    },
    onCloseSuccessTopUpModal () {
      this.successTopUpModal.isOpen = false
    },
    openExpiredTopUpModal () {
      this.expiredTopUpModal.isOpen = true
    },
    onCloseExpiredTopUpModal () {
      this.expiredTopUpModal.isOpen = false
    },
    openWaitingPaymentTopUpModal () {
      this.waitingPaymentTopUpModal.isOpen = true
    },
    onCloseWaitingPaymentTopUpModal () {
      this.waitingPaymentTopUpModal.isOpen = false
    },
    resetFilter () {
      this.temporaryFilter.status = ''
      this.temporaryFilter.paymentMethod = ''
      this.temporaryFilter.topUpDate = ''
    },
    openModalByURLParams () {
      const urlString = window.location.href
      const url = new URL(urlString)
      const openModalURLParams = url.searchParams.get('openModal')

      if (openModalURLParams === 'YES') this.topUpModal.isOpen = true
    },
    getDetailTopUpData (
      idDistributorBalanceOrder,
      checkTransactionStatus = false
    ) {
      this.loading = true

      axios.defaults.headers = {
        accessToken: this.token,
        milliseconds: this.expired
      }

      axios
        .post('/top-up/detail', {
          id_client: this.$store.state.idClient,
          id: idDistributorBalanceOrder
        })
        .then(response => {
          let rowData = [response.data.data]

          rowData = rowData.map(row => ({
            ...row,
            amount: currencyRupiah(row.amount || 0),
            status_bo: row.status_bo ? row.status_bo : '-',
            va_payment_fee: currencyRupiah(row.va_payment_fee || 0),
            va_gross_amount: currencyRupiah(row.va_gross_amount || 0),
            va_no: row.va_no ? row.va_no : '-',
            formatted_va_expired_at: moment(row.va_expired_at).format(
              'dddd, DD MMMM YYYY | HH:mm:ss'
            ),
            yearCountdown:
              row.status_bo.toLowerCase() !== 'cancel'
                ? moment(row.va_expired_at).format('YYYY')
                : moment(row.va_expired_at).add(1, 'y'), // Must add 1 year to force Computed refresh in countdown component
            monthCountdown: moment(row.va_expired_at).format('MM'),
            dateCountdown: moment(row.va_expired_at).format('DD'),
            hourCountdown: moment(row.va_expired_at).format('HH'),
            minuteCountdown: moment(row.va_expired_at).format('mm'),
            secondCountdown: moment(row.va_expired_at).format('ss'),
            milisecondCountdown: '00'
          }))

          this.modalData = rowData.shift()

          if (this.modalData.status_bo.toLowerCase() === 'cancel') {
            this.openExpiredTopUpModal()
          } else if (this.modalData.status_bo.toLowerCase() === 'waiting') {
            this.openWaitingPaymentTopUpModal()
          } else if (this.modalData.status_bo.toLowerCase() === 'closed') {
            this.openSuccessTopUpModal()
          } else if (
            this.modalData.status_bo.toLowerCase() === 'open' &&
            checkTransactionStatus
          ) {
            this.openWaitingPaymentTopUpModal()
            this.onCloseDetailsTopUpModal()
          } else {
            this.openDetailsTopUpModal()
          }

          this.loading = false
        })
        .catch(error => {
          this.lists = []
          if (error.response.data.code === 'TOE001') {
            this.$store.dispatch('refresh')
          }
          if (error.response.data.code === 'TOE002') {
            this.$store.dispatch('clear')
          }
          this.text = error.response.data.message
          this.loading = false
        })
    },
    topUp (data) {
      this.loading = true
      axios.defaults.headers = {
        accessToken: this.token,
        milliseconds: this.expired
      }
      axios
        .post('/top-up/', {
          amount: data.amount,
          id_payment_method: data.paymentMethod,
          id_client: this.$store.state.idClient
        })
        .then(response => {
          this.loadDataTable()
          const id = response.data.data.id_distributor_balance_order
          this.getDetailTopUpData(id)
        })
        .catch(error => {
          this.lists = []
          if (error.response.data.code === 'TOE001') {
            this.$store.dispatch('refresh')
          }
          if (error.response.data.code === 'TOE002') {
            this.$store.dispatch('clear')
          }
          this.text = error.response.data.message
          this.loading = false
        })
    },
    onCheckTransactionStatus (idDistributorBalanceOrder) {
      this.getDetailTopUpData(idDistributorBalanceOrder, true)
    },
    onRowClicked (row) {
      this.modalData = row
      const id = row.id_distributor_balance_order
      this.getDetailTopUpData(id)
    },
    onApplyFilter () {
      this.loadDataTable()
    },
    onRefresh () {
      this.getBalance()
      this.loadDataTable()
    },
    loadDataTable () {
      this.loading = true
      let { page, totalItems } = this.pagination

      axios.defaults.headers = {
        accessToken: this.token,
        milliseconds: this.expired
      }

      if (
        this.filters.start !== this.defaultFilters.start ||
        this.filters.end !== this.defaultFilters.end
      ) {
        this.pagination.page = 1
        page = 1
      }

      axios
        .post('/top-up/list', {
          request_id: `Req-${new Date().getTime()}-hist`,
          start_date: this.filters.start + ' 00:00:00',
          end_date: this.filters.end + ' 23:59:59',
          current_page: page,
          max_records: totalItems,
          sort: 'desc',
          id_client: this.$store.state.idClient,
          id_payment_method: this.temporaryFilter.paymentMethod,
          status: this.temporaryFilter.status
        })
        .then(response => {
          this.lists = response.data.data

          this.lists = this.lists.map(row => ({
            ...row,
            amount: currencyRupiah(row.amount || 0),
            status_bo: row.status_bo ? row.status_bo : '-',
            va_payment_fee: currencyRupiah(row.va_payment_fee || 0),
            va_gross_amount: currencyRupiah(row.va_gross_amount || 0)
          }))

          this.loading = false
        })
        .catch(error => {
          this.lists = []
          if (error.response.data.code === 'TOE001') {
            this.$store.dispatch('refresh')
          }
          if (error.response.data.code === 'TOE002') {
            this.$store.dispatch('clear')
          }
          this.text = error.response.data.message
          this.loading = false
        })
    },
    getPaymentMethodList () {
      this.paymentMethod = []
      this.loading = true

      axios.defaults.headers = {
        accessToken: this.token,
        milliseconds: this.expired
      }
      axios
        .post('/top-up/payment-method')
        .then(response => {
          const data = response.data.data
          this.paymentMethod = data.map(row => ({
            ...row,
            text: `${row.name} (${row.category})`,
            value: `${row.id}`
          }))
          this.loading = false
        })
        .catch(error => {
          this.lists = []
          if (error.response.data.code === 'TOE001') {
            this.$store.dispatch('refresh')
          }
          if (error.response.data.code === 'TOE002') {
            this.$store.dispatch('clear')
          }
          this.text = error.response.data.message
          this.loading = false
        })
    },
    getBalance () {
      this.$emit('loading', true)
      this.balance = null
      this.date = null
      this.hour = null
      this.min = null
      this.sec = null

      let appkey = this.appkey
      let appid = this.appid
      let accessToken = this.token
      let url = `/balance?app_id=${appid}&app_key=${appkey}&accesstoken=${accessToken}`

      axios
        .get(url)
        .then(response => {
          const resBalance = response.data.data.balance
          this.balance = currencyRupiah(resBalance.split(',').join(''))

          let datecheck = response.data.data.date
          let arrange = datecheck.split(' ')[0]
          let months = [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December'
          ]
          this.date =
            arrange.split('-')[2] +
            ' ' +
            months[Number(arrange.split('-')[1]) - 1] +
            ' ' +
            arrange.split('-')[0]

          let hour = String(new Date().getHours())
          this.hour = hour.length === 1 ? '0' + hour : hour
          this.min = datecheck.split(' ')[1].split(':')[1]
          this.sec = datecheck.split(' ')[1].split(':')[2]
        })
        .catch(error => {
          if (error.response.data.code === 'TOE001') {
            this.$store.dispatch('refresh')
          }
          if (error.response.data.code === 'TOE002') {
            this.$store.dispatch('clear')
          }
        })
        .finally(() => {
          this.$emit('loading', false)
        })
    },
    forceRerender () {
      this.topUpModalComponentKey += 1
      this.detailsTopUpModalComponentKey += 1
    }
  },
  mounted () {
    this.openModalByURLParams()
    this.loadDataTable()
    this.getPaymentMethodList()
    this.getBalance()
    if (localStorage.getItem('guideTopUp') === 'unread') {
      this.$tours['topupTour'].start()
    }
  }
}
</script>
<style scoped>
.content-wrapper {
  padding: 1em;
  background: white;
  border-radius: 3px;
  box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%),
    0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
}

.balance-info {
  margin: 0.5em;
  padding: 1.85em;
  background: white;
  border-radius: 3px;
  box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%),
    0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
}

.balance-filter {
  margin: 0.5em;
  padding: 1em;
  background: white;
  border-radius: 3px;
  box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%),
    0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
}

.row-cursor-pointer >>> tbody tr :hover {
  cursor: pointer;
}
</style>
